module.exports = __webpack_public_path__ + "somalia.svg?bc593c33adc913e37f6ae78fd21b2381";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/somalia.svg
// module id = 297
// module chunks = 10